import React, { useState } from 'react'
import { Button} from 'react-bootstrap';
import { FormControl, FormHelperText, Input, InputLabel } from '@material-ui/core';
import emailjs from 'emailjs-com';

const SERVICE_ID = process.env.REACT_APP_SERVICE_ID
const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID
const USER_ID = process.env.REACT_APP_USER_ID

export default function Contact() {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [city, setCity] = useState('')
    const [message, setMessage] = useState('')
    const [nameErr, setNameErr] = useState(false)
    const [emailErr, setEmailErr] = useState(false)
    const [phoneErr, setPhoneErr] = useState(false)
    const [cityErr, setCityErr] = useState(false)
    const [messageErr, setMessageErr] = useState(false)
    

    const handleSubmit = (event) => {
        event.preventDefault();
        // eslint-disable-next-line no-useless-escape
        if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
            setEmailErr(true)
            return
        }
        else {
            setEmailErr(false)
        }
        if(!name || !phone || !message || !city){
            !name && setNameErr(true)
            !phone && setPhoneErr(true)
            !city && setCityErr(true)
            !message && setMessageErr(true)
        }
        else {
            name && setNameErr(false)
            phone && setPhoneErr(false)
            city && setCityErr(false)
            message && setMessageErr(false)
            emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, event.target, USER_ID)
            .then((result) => {
                setName('')
                setEmail('')
                setPhone('')
                setCity('')
                setMessage('')
                alert('Appointment submitted successfully! Dr. Emad will get in touch with you soon.')
            }, (error) => {
                console.log(error.text);
            });
        }
    }
    return (
        <div id="contact">
            <div className="form">
                <div>
                    <h2 className="services-heading">Book an Appointment</h2>
                </div>
                <p className="heading-p">Don't waste your time, make it online</p>
                <hr className="underline" />
                <form className={'in-form'} noValidate autoComplete="off" onSubmit={handleSubmit}>
                <div className='input-div'>
                <FormControl error={nameErr} className='input-field'>
                    <InputLabel htmlFor="component-error">Full Name</InputLabel>
                    <Input
                        id="component-error"
                        type='text'
                        value={name}
                        name='full_name'
                        onChange={(e) => {setName(e.target.value) }}
                        aria-describedby="component-error-text"
                        var
                    />
                    {nameErr && <FormHelperText id="component-error-text">Please enter your name</FormHelperText>}
                </FormControl>
                </div>
                <div className='input-div'>
                <FormControl error={emailErr} className='input-field'>
                    <InputLabel htmlFor="component-error">Email</InputLabel>
                    <Input
                        id="component-error"
                        value={email}
                        type='email'
                        name='email'
                        onChange={(e) => {setEmail(e.target.value) }}
                        aria-describedby="component-error-text"
                    />
                    {emailErr && <FormHelperText id="component-error-text">Invalid Email</FormHelperText>}
                </FormControl>
                </div>
                <div className='input-div'>
                <FormControl error={phoneErr} className='input-field'>
                    <InputLabel htmlFor="component-error">Phone Number</InputLabel>
                    <Input
                        id="component-error"
                        value={phone}
                        type='text'
                        name='phone'
                        onChange={(e) => {
                            var regex = /^[0-9]+$/;
                            if (
                                e.target.value.match(regex)
                            ) {
                                setPhone(e.target.value);
                            }
                        }}
                        aria-describedby="component-error-text"
                    />
                    {phoneErr && <FormHelperText id="component-error-text">Please enter your phone number</FormHelperText>}
                </FormControl>
                </div>
                <div className='input-div'>
                <FormControl error={cityErr} className='input-field'>
                    <InputLabel htmlFor="component-error">City/Country</InputLabel>
                    <Input
                        id="component-error"
                        value={city}
                        type='text'
                        name='city'
                        onChange={(e) => {setCity(e.target.value) }}
                        aria-describedby="component-error-text"
                    />
                    {cityErr && <FormHelperText id="component-error-text">Please enter the city/country you live in</FormHelperText>}
                </FormControl>
                </div>
                <div className='input-div'>
                <FormControl error={messageErr} className='input-field'>
                    <InputLabel htmlFor="component-error">Type your query</InputLabel>
                    <Input
                        id="component-error"
                        value={message}
                        multiline
                        name='message'
                        maxRows={4}
                        onChange={(e) => {setMessage(e.target.value) }}
                        aria-describedby="component-error-text"
                        variant='outlined'
                    />
                    {messageErr && <FormHelperText id="component-error-text">Please enter your query</FormHelperText>}
                </FormControl>
                </div>
                <Button type="submit" className='submit-btn'>
                    Submit
                </Button>
                </form>
            </div>
        </div>
    )
}
